// src/pages/collection/[collection].js

import React from "react";
import { useRouter } from "next/router";
import Collection_items from "../../components/collectrions/Collection_items";
import Meta from "../../components/Meta";
import { HeadLine } from "../../components/component";

const Collection = () => {
  const router = useRouter();
  const pid = router.query.collection;

  return (
    <>
      <Meta title={`${pid} || GMJA Arc-Hive`} />

      <HeadLine
        text="Architectural Elements"
        classes="font-display text-jacarta-700 py-16 mt-24 text-center text-4xl font-medium dark:text-white"
      />
      <Collection_items />
    </>
  );
};

export default Collection;
